import React from 'react';
import withVenue from '../../hoc/withVenue';
import PayoutsSection from './PayoutsSection';

const Payouts = () => <PayoutsSection />;

export default withVenue(Payouts);
